<div class="ten" class="row no-gutters">
  <div class="col-md-12">
    <input type="range" name="outOfTen" [disabled]="disabled" [class.slider]="!disabled" [class.dis-slider]="disabled" id="outOfTen" min="1" max="10" value="1" (change)="select($event)">
  </div>
  <label class="col-md-2 col-md-offset-5 noselect text-center text-nowrap m-top-10" style="padding: 0">{{cleanSelect(selection)}} / 10</label>
</div>